import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

function parseHash() {
  var hash = window.location.hash.substring(1);
  var params = {};

  if (hash.length < 5) return params;

  hash.split('&').forEach(function(value) {
    if (!value) return;

    var pair = value.split('=');
    if (pair.length < 2) return;

    params[pair[0]] = pair[1];
  });

  if (params.gid) params.gid = parseInt(params.gid, 10);
  if (!Object.prototype.hasOwnProperty.call(params, 'pid')) return params;

  params.pid = parseInt(params.pid, 10);
  return params;
}

function openGallery(galleries, gid, pid, customOptions) {
  var pswpElement = document.querySelector('.pswp');
  var galleryData = galleries[gid - 1];
  if (!pswpElement || !galleryData) return;

  var items = galleryData.items;
  var options = Object.assign({
    index: pid,
    galleryUID: gid,
    getThumbBoundsFn: function(index) {
      var thumbnail = items[index].el.children[0];
      var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
      var rect = thumbnail.getBoundingClientRect();

      return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
    }
  }, customOptions || {});

  var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
}

function initPhotoSwipe(galleryElements, customOptions) {
  var galleries = [];

  galleryElements.forEach(function(gallery, galleryIndex) {
    galleries.push({ id: galleryIndex, items: [] });

    gallery.querySelectorAll('a.img').forEach(function(link, photoIndex) {
      var size = link.dataset.size.split('x');
      if (size.length !== 2) throw new SyntaxError('Missing data-size attribute.');

      link.dataset.galleryId = galleryIndex + 1;
      link.dataset.photoId = photoIndex;

      galleries[galleryIndex].items.push({
        src: link.href,
        msrc: link.querySelector('img').getAttribute('src'),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10),
        title: link.querySelector('figcaption').innerHTML,
        el: link
      });
    });

    // Turbo can restore cached DOM attributes without restoring listeners.
    // Replacing the gallery-level handler keeps rebinding idempotent across repeated turbo:load events.
    if (gallery.photoswipeClickHandler) gallery.removeEventListener('click', gallery.photoswipeClickHandler);
    gallery.photoswipeClickHandler = function(event) {
      var link = event.target.closest('a.img');
      if (!link || !gallery.contains(link)) return;

      event.preventDefault();
      openGallery(galleries, parseInt(link.dataset.galleryId, 10), parseInt(link.dataset.photoId, 10), customOptions);
    };
    gallery.addEventListener('click', gallery.photoswipeClickHandler);
  });

  var hashData = parseHash();
  if (hashData.pid > 0 && hashData.gid > 0) {
    openGallery(galleries, hashData.gid, hashData.pid, customOptions);
  }
}

document.addEventListener('turbo:load', function() {
  initPhotoSwipe(Array.from(document.querySelectorAll('.product-gallery')), {
    bgOpacity: 0.95,
    loop: true,
    history: false
  });
});
